export default [
  {
    value: "01",
    label: "Government Instrumentality",
  },
  {
    value: "02",
    label: "Title-Holding Corporation",
  },
  {
    value: "03",
    label: "Charitable Organization",
  },
  {
    value: "03",
    label: "Educational Organization",
  },
  {
    value: "03",
    label: "Literary Organization",
  },
  {
    value: "03",
    label: "Organization to Prevent Cruelty to Animals",
  },
  {
    value: "03",
    label: "Organization to Prevent Cruelty to Children",
  },
  {
    value: "03",
    label: "Organization for Public Safety Testing",
  },
  {
    value: "03",
    label: "Religious Organization",
  },
  {
    value: "03",
    label: "Scientific Organization",
  },
  {
    value: "04",
    label: "Civic League",
  },
  {
    value: "04",
    label: "Local Association of Employees",
  },
  {
    value: "04",
    label: "Social Welfare Organization",
  },
  {
    value: "05",
    label: "Agricultural Organization",
  },
  {
    value: "05",
    label: "Horticultural Organization",
  },
  {
    value: "05",
    label: "Labor Organization",
  },
  {
    value: "06",
    label: "Board of Trade",
  },
  {
    value: "06",
    label: "Business League",
  },
  {
    value: "06",
    label: "Chamber of Commerce",
  },
  {
    value: "06",
    label: "Real Estate Board",
  },
  {
    value: "07",
    label: "Pleasure, Recreational, or Social Club",
  },
  {
    value: "08",
    label: "Fraternal Beneficiary Society, Order or Association",
  },
  {
    value: "09",
    label: "Voluntary Employees' Beneficiary Association (Non-Govt. Emps.)",
  },
  {
    value: "09",
    label: "Voluntary Employees' Beneficiary Association (Govt. Emps.)",
  },
  {
    value: "10",
    label: "Domestic Fraternal Societies and Associations",
  },
  {
    value: "11",
    label: "Teachers Retirement Fund Assoc.",
  },
  {
    value: "12",
    label: "Benevolent Life Insurance Assoc.",
  },
  {
    value: "12",
    label: "Mutual Ditch or Irrigation Co.",
  },
  {
    value: "12",
    label: "Mutual Cooperative Telephone Co.",
  },
  {
    value: "12",
    label: "Organization Like Those on Three Preceding Lines",
  },
  {
    value: "13",
    label: "Burial Association",
  },
  {
    value: "13",
    label: "Cemetery Company ",
  },
  {
    value: "14",
    label: "Credit Union",
  },
  {
    value: "14",
    label: "Other Mutual Corp. or Assoc.",
  },
  {
    value: "15",
    label: "Mutual Insurance Company or Assoc. Other Than Life or Marine",
  },
  {
    value: "16",
    label: "Corp. Financing Crop Operations",
  },
  {
    value: "17",
    label: "Supplemental Unemployment Compensation Trust or Plan",
  },
  {
    value: "18",
    label: "Employee Funded Pension Trust (Created Before 6/25/59)",
  },
  {
    value: "19",
    label: "Post or Organization of War Veterans",
  },
  {
    value: "20",
    label: "Legal Service Organization",
  },
  {
    value: "21",
    label: "Black Lung Trust",
  },
  {
    value: "22",
    label: "Multiemployer Pension Plan",
  },
  {
    value: "23",
    label: "Veterans Assoc. Formed Prior to 1880",
  },
  {
    value: "24",
    label: "Trust Described in Sect. 4049 of ERISA",
  },
  {
    value: "25",
    label: "Title Holding Co. for Pensions, etc.",
  },
  {
    value: "26",
    label: "State-Sponsored High Risk Health Insurance Organizations",
  },
  {
    value: "27",
    label: "State-Sponsored Workers' Compensation Reinsurance",
  },
  {
    value: "29",
    label: "ACA 1322 Qualified Nonprofit Health Insurance Issuers",
  },
  {
    value: "40",
    label: "Apostolic and Religious Org. (501(d))",
  },
  {
    value: "50",
    label: "Cooperative Hospital Service Organization (501(e))",
  },
  {
    value: "60",
    label:
      "Cooperative Service Organization of Operating Educational Organization (501(f))",
  },
  {
    value: "70",
    label: "Child Care Organization (501(k))",
  },
  {
    value: "71",
    label: "Charitable Risk Pool",
  },
  {
    value: "81",
    label: "Qualified State-Sponsored Tuition Program",
  },
  {
    value: "92a  fi",
    label: "4947(a)(1) - Private Foundation (Form 990PF Filer)",
  },
];
